import { useCallback, useEffect, useState } from 'react';
import placesLibraryLoader from './placesLibraryLoader';
import { useServerData } from '../../context/ServerDataContext';

export default function usePlacesLibrary() {
    const { appSettings } = useServerData();
    const apiKey = (appSettings && appSettings.googlePlacesApiKey) || '';
    const [placesLibrary, setPlacesLibrary] = useState(null);

    useEffect(() => placesLibraryLoader.subscribe(() => {
        setPlacesLibrary(null);
    }), []);

    const requestPlacesLibrary = useCallback(() => {
        placesLibraryLoader.load(apiKey).then(setPlacesLibrary);
    }, [apiKey]);

    return {
        placesLibrary,
        requestPlacesLibrary,
        markPlacesLibraryUnusable: placesLibraryLoader.markUnusable,
        reportPlacesQuotaExceeded: placesLibraryLoader.reportQuotaExceeded,
    };
}
